/**
 * 사용자 아이디 형식 검증
 * @description 문자열이 영문, 숫자, 기호로만 이루어져있는지 체크하는 함수 (\'"` 제외)
 * @returns boolean, (true: 허용하는 문자로만 이루어짐, false: 허용하지 않는 문자열 포함)
 */

const validateIdFormat = (str: string) => {
  const regex = /^[a-zA-Z\d~!@#$%^&*()\-_=+|[\]{};:,.<>/?]+$/;

  return regex.test(str);
};

export default validateIdFormat;
